/**
 * @file Created on Thu Nov 15 2018
 * @author wangyongqing <wangyongqing01@baidu.com>
 */
import UA from './ua';
/**
 * 是否是手百产品，支持矩阵产品
 * @function isBox
 * @param {''|lite|pro|info|mission} [subName=''] - 手百矩阵产品标识
 * @param {string} ua - 传入的 userAgent，如果不传则取 navigator.userAgent
 * @return { boolean} 是否是手百判断结果
 * @example
 * isBoxApp()
 * isBoxApp('lite')
 * isBoxApp('pro', 'fdafafdafaf pro baiduboxapp')
 */
export default (subName = '', ua = UA) => {
    if (subName === 'main') {
        subName = '';
    }

    // baiduboxapp: 框的常规UA
    // biduboxapp:  个别网站会触发内核的风控策略(比如域名以le.com结尾)，UA会被替换
    const reg =  / (baiduboxapp|biduboxapp)\//i;
    if (reg.test(ua) === false) {
        // 框外
        return false;
    }

    let matchRes = ua.match(reg);
    let sign = matchRes[1];
    if (!~ua.indexOf(`${subName} ${sign}`)) {
        // 具体的 app ：主线 / lite / info / pro 等
        return false;
    }

    return true;
};
